import { TableContainer, Paper, Table, TableHead, TableRow, TableCell, TableBody } from '@mui/material';
import DatasetsRow from './DatasetsRow';





const ColumnsTable = ({ list, pageNo, itemsPerPage, setLoader, handleSubmit, toogleHideModal, value, ...other }) => {

    const actionOption = (row) => {
        if (value === "Hidden Temporarily") {
            return (
                <div className="cm_active">
                    Unhide
                </div>
            )
        }
        else if (value === "Hidden Permanently") {
            return (
                <div className="cm_active">
                    Unhide
                </div>
            )
        }
        else if (value === "All") {
            return (
                <div className={(!row?.isHidden || !row?.joinHiddenField) ? "cm_inactive" : "cm_active"}>
                    {(!row?.isHidden || !row?.joinHiddenField) ? 'Hide' : 'Unhide'}
                </div>
            )
        }

    }

    return (
        <TableContainer component={Paper} {...other}>
            <Table aria-label="customized table" className="custom-table datasets-table">
                <TableHead >
                    <TableRow className='cm_table_head'>
                        <TableCell >#</TableCell>
                        <TableCell >Field Name</TableCell>
                        <TableCell >Datatype</TableCell>
                        <TableCell>Sql</TableCell>
                        <TableCell >Hidden Temporarily</TableCell>
                        <TableCell >Hidden Permanently</TableCell>
                        <TableCell >Action</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {list && list.length > 0 && list.map((row, i) => (
                        <TableRow key={i}>
                            <TableCell >{(i + 1) + ((pageNo - 1) * itemsPerPage)}</TableCell>
                            <TableCell className="datasetname-cell">{row?.displayName || row?.name}</TableCell>
                            <TableCell >{row?.dataType}</TableCell>
                            <TableCell>{(row?.dataSetType === "MEASURE" ? (row?.displayCalculatedField || row?.sql) : row?.sql)}</TableCell>
                            <TableCell >{row?.isHidden?.toString() === "true" ? "Yes" : "No"}</TableCell>
                            <TableCell >{row?.joinHiddenField?.toString() === "true" ? "Yes" : "No"}</TableCell>
                            <TableCell>
                                <span onClick={(e) => { handleSubmit(e, row); toogleHideModal(row) }} className="datasetname-cell">{actionOption(row)}
                                </span>
                            </TableCell>

                        </TableRow>

                    ))}
                </TableBody>
            </Table>
        </TableContainer>
    )

}

export default ColumnsTable